export default {
    1: {
        id: 1,
        text: 'Pendiente',
        type: 'danger'
    },
    2: {
        id: 2,
        text: 'Confirmado',
        type: 'success'
    },
    3: {
        id: 3,
        text: 'Rechazado',
        type: 'error'
    },
    4: {
        id: 4,
        text: 'Vencido',
        type: 'dark'
    },
};

export const colorStatus = {
    confirmed: {
        color: '#1AC740',
        background: 'rgba(26, 199, 64, 0.20)'
    },
    pending: {
        color: '#F4AB34',
        background: 'rgba(244, 171, 52, 0.20)'
    },
    defeated: {
        color: '#B71E15',
        background: 'rgba(183, 30, 21, 0.20)'
    }
};
